import { Modal } from "@mui/material";
import classNames from "classnames";
import { ReactElement } from "react";
import React from "react";
// constants
import { useTranslation } from "react-i18next";

// icons
import styles from "./styles.module.scss";

interface Props {
  open: boolean;
  handleClose: () => void;
  children?: ReactElement;
}

const PaymentModal = ({ open, handleClose, children }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div dir="rtl">
      <Modal
        open={open}
        onClose={handleClose}
        className={styles.modalContainer}>
        <div className={classNames(styles.modalContent, styles.card)}>
          <div className={styles.header}>
            <div className={styles.closeModal} onClick={handleClose}>
              <img src="/assets/images/svg/closeDark.svg" alt="close" />
            </div>
            <h1>{t("lbl_pay_contract_title")}</h1>
          </div>
          {children}
        </div>
      </Modal>
    </div>
  );
};

export default PaymentModal;
